export default {
    SET_USERNAME: 'SET_USERNAME',
    SET_TOKEN_INFORMATION: 'SET_TOKEN_INFORMATION',
    SET_USER_INFORMATION: 'SET_USER_INFORMATION',
    CLEAR_USER_INFORMATION: 'CLEAR_USER_INFORMATION',
    CLEAR_TOKEN_INFORMATION: 'CLEAR_TOKEN_INFORMATION',
    SHOW_LOGIN_MODAL: 'SHOW_LOGIN_MODAL',
    HIDE_LOGIN_MODAL: 'HIDE_LOGIN_MODAL',
    SHOW_REGISTER_MODAL: 'SHOW_REGISTER_MODAL',
    HIDE_REGISTER_MODAL: 'HIDE_REGISTER_MODAL',
};



// WEBPACK FOOTER //
// ./src/reducers/UserReducer/UserConstants.js